import classNames from 'classnames';
import { useState } from 'react';

import { FormConsult } from '~containers/Forms/FormConsult/FormConsult';
import MessageIcon from '~public/static/images/icons/messages_outline_28.svg';

import styles from './ButtonConsult.module.scss';
import { ButtonConsultProps } from './ButtonConsult.types';

export const ButtonConsult = ({
  className,
  dataTest,
  formLabel,
  logo,
  text = 'Получить консультацию',
}: ButtonConsultProps) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <a
        className={classNames(className, styles.button)}
        onClick={handleOpen}
        data-test={dataTest}
      >
        <MessageIcon className={styles.consultIcon} />
        {text}
      </a>
      <FormConsult
        logo={logo}
        onClose={handleClose}
        active={open}
        formLabel={formLabel}
      />
    </>
  );
};
